require('./accountDebitsEditStep1.scss');

const PropTypes = require('prop-types');
const React = require('react');
// @ commons
const { formatText, FormattedText } = require('core/i18n').i18n;
// @ components
const DropdownAccounts = require('components/dropdownAccounts/dropdownAccounts');
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');

class AccountDebitsEditStep1 extends React.Component {

    getAccountsIndexes(accounts, accountsMap) {
        return accounts.filter(accountId => {
            const accountProduct = accountsMap.getIn([accountId, 'newProduct']);
            return accountProduct === '300' // CUENTA CORRIENTE
        });
    }

    render(){
        const {
            accountId,
            accountHolder,
            accountInfo,
            balance,
            newAccountId,
            onAccountChange,
            showError,
            immAccounts,
            isInactiveAccountsEnabled,
        } = this.props;
        const accountsById = immAccounts.get('byId');
        const accountsIndexes = this.getAccountsIndexes(immAccounts.get('byOrder').toJS(), accountsById);
        const errorMsg = (showError) ? formatText('debitsEdit-errorAccount') : '';
        const tooltipMsgContent = isInactiveAccountsEnabled ? 'inactiveAccounts-inactiveAccounts_dropdownCommonToolTip' : '';

        return (
            <section className="debits-edit">
                <h4 className="debits-edit__header">
                    <FormattedText value="debitsEdit-stepOneTitle" />
                </h4>
                <p className="debits-edit__subtitle"><FormattedText value="debitsEdit-stepOneSubTitle" /></p>
                <OKInformativeList columns={3}>
                    <OKInformativeListItem
                        title={formatText('debitsEdit-beneficiary')}
                        bodyText={accountHolder}
                        bodyWordBreak={false}
                    />
                    <OKInformativeListItem
                        title={formatText('debitsEdit-accountName')}
                        bodyText={accountInfo}
                    />
                    <OKInformativeListItem
                        title={formatText('debitsEdit-balance')}
                        bodyText={balance}
                    />
                </OKInformativeList>
                <div className="debits-edit__account-select">
                    <p className="debits-edit__label"><FormattedText value="debitsEdit-dropdownTitle" /></p>
                    <DropdownAccounts
                        immAccounts={accountsById}
                        currentAccountId={newAccountId}
                        accountsIndexes={accountsIndexes}
                        onAccountChange={onAccountChange}
                        filterId={accountId}
                        error={showError}
                        errorMsg={errorMsg}
                        tooltipMsg={tooltipMsgContent}
                        showInactiveAccountsAsBlocked={isInactiveAccountsEnabled}
                    />
                </div>
            </section>
        );
    }
}

AccountDebitsEditStep1.propTypes = {
    accountId: PropTypes.string.isRequired,
    accountHolder: PropTypes.string.isRequired,
    accountInfo: PropTypes.string.isRequired,
    balance: PropTypes.string.isRequired,
    immAccounts: PropTypes.object.isRequired,
    isInactiveAccountsEnabled: PropTypes.bool.isRequired,
    onAccountChange: PropTypes.func.isRequired,
    showError: PropTypes.bool.isRequired,
    newAccountId: PropTypes.string.isRequired
};

module.exports = AccountDebitsEditStep1;
